declare const paypal;
export const isPaypalDefined = () => {
	try {
		if (typeof paypal !== 'undefined') {
			return true;
		}
		return false;
	} catch (error) {
		return false;
	}
};